import { render } from "./VideosView.vue?vue&type=template&id=56592412&scoped=true"
import script from "./VideosView.vue?vue&type=script&lang=js"
export * from "./VideosView.vue?vue&type=script&lang=js"

import "./VideosView.vue?vue&type=style&index=0&id=56592412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56592412"]])

export default __exports__